export default __webpack_public_path__ + "static/media/VikaCh2.d24725e4.png";